import { render, staticRenderFns } from "./crm-settings.vue?vue&type=template&id=3611b3c8&"
import script from "./crm-settings.vue?vue&type=script&lang=js&"
export * from "./crm-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports